




















import Vue from 'vue'
import ShiftBadge from './ShiftBadge.vue'
import Calendar from './Calendar.vue'
import { state } from '../store'
import dayjs from 'dayjs'
export default Vue.extend({
  components: {
    Calendar,
    ShiftBadge,
  },
  props: {
    year: {
      type: Number,
      default: 2020,
    },
    days: {
      type: Array,
      default: () => [],
    },
    shiftList: {
      default: () => [],
    },
    detail: {
      default: () => ({}),
    },
  },

  methods: {
    collectData(data = null) {
      let result = []
      let year = null
      for (let i = 0; i < 12; i++) {
        const res = this.$refs[`calendar${i + 1}`][0].collectArrangedDays()
        if (res) {
          result = result.concat(res)
        } else {
          return null
        }
      }
      let others

      if (!data) {
        // 编辑
        others = (this.detail?.otherCalendarDayVOList || []).map(item => ({
          date: dayjs(item.calendarDate).format('YYYY-MM-DD'),
          prioritized: item.isHighPriority === 1,
        }))
      } else {
        // 新建
        others = data.map(item => ({
          date: dayjs(item.calendarDate).format('YYYY-MM-DD'),
          prioritized: item.isHighPriority === 1,
        }))
      }
      console.log(others)
      for (let i = 0; i < result.length; i++) {
        if (result[i].prioritized) {
          if (i === 0) {
            const one = dayjs(result[i].time)
              .add(-1, 'day')
              .format('YYYY-MM-DD')
            const two = dayjs(result[i].time)
              .add(-2, 'day')
              .format('YYYY-MM-DD')
            const found = others.find(item => (item.date === one || item.date === two) && item.prioritized)
            if (found) {
              return null
            } else if (result[i + 1].prioritized || result[i + 2].prioritized) {
              return null
            } else {
              continue
            }
          }
          if (i === 1) {
            const two = dayjs(result[i].time)
              .add(-2, 'day')
              .format('YYYY-MM-DD')
            const found = others.find(item => item.date === two && item.prioritized)
            if (found) {
              return null
            } else if (result[i - 1].prioritized || result[i + 1].prioritized || result[i + 2].prioritized) {
              return null
            } else {
              continue
            }
          }
          if (i === result.length - 1) {
            const one = dayjs(result[i].time)
              .add(1, 'day')
              .format('YYYY-MM-DD')
            const two = dayjs(result[i].time)
              .add(2, 'day')
              .format('YYYY-MM-DD')
            const found = others.find(item => (item.date === one || item.date === two) && item.prioritized)
            if (found) {
              return null
            } else if (result[i - 1].prioritized || result[i - 2].prioritized) {
              return null
            } else {
              continue
            }
          }
          if (i === result.length - 2) {
            const two = dayjs(result[i].time)
              .add(2, 'day')
              .format('YYYY-MM-DD')
            const found = others.find(item => item.date === two && item.prioritized)
            if (found) {
              return null
            } else if (result[i - 1].prioritized || result[i + 1].prioritized || result[i - 2].prioritized) {
              return null
            } else {
              continue
            }
          }
          if (
            result[i - 1].prioritized ||
            result[i + 1].prioritized ||
            result[i - 2].prioritized ||
            result[i + 2].prioritized
          ) {
            return null
          }
        }
      }

      return result
        .filter(item => item.arranged)
        .map(item => ({
          modelId: item.shift.id || '0',
          calendarDate: dayjs(new Date(item.time))
            .add(1, 'day')
            .toDate(),
          isHighPriority: item.prioritized ? 1 : 0,
        }))
    },
  },
})
